export const isVision = name =>
  name ? name.trim().toLowerCase().includes('vision dtg printer') : false;
